import FieldPopover from "../../../fields3/generic/popover/popover"
import FieldEstimate_Popover from "./components/popover/popover"
import FieldEstimate_InlineValueNotEmpty from "./components/inline-edit/value-not-empty"
import FieldEstimate_FormValueNotEmpty from "./components/form/value-not-empty"
import FieldConfig from "../../proto/field-config";
import {GROUP_ESTIMATE, GROUP_MISC} from "../../../gd/const/fields/field2-groups";
import FieldEstimate_View from "./render/view";
import normalizeNumber from "../../import/normalize/normalize-number";
import ImportFromCSVModule from "../../../gd-modules/import-from-csv/import-from-csv-module";
import FieldTaskEstimate_ConditionForm from "./render/condition"
import {
    ConditionType_IsNull,
    ConditionType_NotNull,
    ConditionType_NumberEquals,
    ConditionType_NumberGreaterThan,
    ConditionType_NumberLessThan
} from "../../../model2/conditions/condition-types"
import {SortDirection} from "../../../data-structures/sort"
import AggregateNumber from "../../../fields/aggregate/aggregate-number"
import AggregateTime from "../../../fields/system/components/aggregate-time"
import FieldEstimate_ViewSmall from "./render/view-small";
import FieldEstimate_InlineValueEmpty from "./components/inline-edit/value-empty";
import Task from "../../../model2/task/task";
import ItemModel from "../../../model2/item/item-model";
import FieldEstimate_Editable from "./render/editable/editable";

export default class FieldEstimate extends FieldPopover {

    FIELD_DEFAULT_WIDTH = 100;

    constructor(config:FieldConfig) {
        super(config);

        this.typeLabel          = "Estimate";
        this.filterType         = null;
        this.typeGroup          = GROUP_ESTIMATE
        this.typeDescription    = "Estimate selector"
        this.icon               = 'i5-time-estimate';

        this.isSearchable       = false;

        this.conditionTypes     = [
            ConditionType_NotNull, ConditionType_IsNull,
            ConditionType_NumberGreaterThan, ConditionType_NumberLessThan, ConditionType_NumberEquals
        ]

        this.clearButton                        = _.get(config,'clearButton',true);

        this.components.PopoverMenu             = FieldEstimate_Popover
        this.components.FormValueNotEmpty       = FieldEstimate_FormValueNotEmpty


        this.components.InlineValueEmpty        = FieldEstimate_InlineValueEmpty
        this.components.InlineValueNotEmpty     = FieldEstimate_InlineValueNotEmpty

        this.renderComponents.view              = FieldEstimate_View
        this.renderComponents.viewSmall         = FieldEstimate_ViewSmall
        this.renderComponents.conditionForm     = FieldTaskEstimate_ConditionForm
        this.renderComponents.editable          = FieldEstimate_Editable

    }

    getDisplayValue(value: any): any {
        return gd.utils.minutesHumanize(value)
    }


    // Custom Methods

    normalizeFromCSVValue(value: string, module: ImportFromCSVModule): any {
        return normalizeNumber(value)
    }

    listItemSortFunctions(sort: SortDirection) {
        return {
            functions   : [(listItem:any) => this.getViewValue(listItem.item) || 0],
            directions  : [sort]
        }
    }

    getAggregateClass() {return AggregateNumber}
    getAggregateOptions() {return [
        gd.const.aggregate.type.SUM,
        gd.const.aggregate.type.MIN,
        gd.const.aggregate.type.MAX,
        gd.const.aggregate.type.MEDIAN,
        gd.const.aggregate.type.AVERAGE
    ]}
    getDefaultAggregateFunction() {return gd.const.aggregate.type.SUM}

    get AggregateComponent() {
        return AggregateTime.bind(null, this.getAggregateOptions())
    }

    // Formula compatability
    getValueType() {
        return gd.const.fields.valueType.FLOAT
    }

    getFormulaValue(model:any) {

        const minutes = this.getViewValue(model)
        if (!minutes) return 0

        return gd.utils.Time.roundHours(minutes)
    }
}
